import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogType = 'website', schema }: SEOProps) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) setMeta('og:url', canonicalUrl, true);
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalUrl) {
      if (!canonicalEl) {
        canonicalEl = document.createElement('link');
        canonicalEl.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute('href', canonicalUrl);
    }

    let schemaEl: HTMLScriptElement | null = null;
    if (schema) {
      schemaEl = document.createElement('script');
      schemaEl.type = 'application/ld+json';
      schemaEl.textContent = JSON.stringify(schema);
      schemaEl.setAttribute('data-dynamic-schema', 'true');
      document.head.appendChild(schemaEl);
    }

    return () => {
      if (schemaEl) {
        schemaEl.remove();
      }
    };
  }, [title, description, keywords, canonicalUrl, ogType, schema]);

  return null;
}